<div
    class="TimeDisplayComponent"
    *ngIf="timeObservable$ | async as time"
    (click)="showMenu = !showMenu"
    (keydown.enter)="showMenu = !showMenu"
>
    <div class="menu">
        <div class="icon">
            <mat-icon svgIcon="{{ time.icon }}"></mat-icon>
        </div>
        <div class="time-description-section">
            <span class="label kp-text-muted">{{ time.label }}</span>
            <span class="time">{{ time.time }} {{ time.utcLabel }}</span>
        </div>
        <div class="icon collapsed">
            <span class="time">{{ time.utcLabel ?? 'UTC+0' }}</span>
        </div>
        <div class="icon">
            <mat-icon svgIcon="chevron-down"></mat-icon>
        </div>
    </div>
</div>

<ce-time-display-menu *ngIf="showMenu"></ce-time-display-menu>
